export enum ENavigationKeys {
  Auth = "auth",
  Panel = "panel",
  SignIn = "sign-in",
  SignUp = "sign-up",
  ForgotPassword = "forgot-password",
  Dashboard = "dashboard",
  AiAssistant = "ai-assistant",
  MyDistrict = "my-district",
  Documents = "documents",
  Drive = "drive",
  Map = "map",
  Reports = "reports",
  ReportsAttendanceBoundaryPreview = "reports-attendance-boundary-preview",
  Users = "users",
  AiAssistantChat = "ai-assistant-chat",

  // Data Management
  Data = "data",
  AccountSettings = "account",
  DataAttendanceZones = "attendance-zones",
  DataDistrictBoundary = "district-boundary",
  DataDistrictBoundaryPreview = "data-district-boundary-preview",
  DataCustomLayers = "custom-layers",
  DataCustomLayersPreview = "data-custom-layers-preview",
  DataFallSnapshot = "fall-snapshot",
  DataMonthlyStudentData = "monthly-student-data",
  DataNewHousing = "new-housing",
  NewHousing = "new-housing-workspace",
  DataSchoolList = "school-list",
  DataCapacityData = "capacity-data",
  AdminPanel = "admin-panel",
  AdminUserManagement = "admin-user-management",
  AdminDashboard = "admin-dashboard",
  DistrictsMap = "districts-map",
  AdminData = "admin-data",
  AiGlossary = "ai-glossary",
  AdminAiGlossary = "admin-ai-glossary",
  AdminChatAlerts = "admin-chat-alerts",
}
